// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1WcfH","label":"Labeled_label__8MTpK","divider":"Labeled_divider__APbog"};